import './solutionPremiumRoutes.styles';
import React from 'react';
import SitesHeroSection from '../components/hero/SitesHeroSection';
import SolutionPageLayout from '../components/premium/SolutionPageLayout';
import { solutionSitesConfig } from '../data/solutionContent';

const SolutionSites: React.FC = () => (
  <SolutionPageLayout hero={<SitesHeroSection />} config={solutionSitesConfig} />
);

export default SolutionSites;
